import React, { Children } from "react"
import { css } from "@emotion/core"
import { Link } from "gatsby"

import { createPopper } from "@popperjs/core"

import { rhythm } from "../utils/typography"

class Ratings extends React.Component {
  constructor(props) {
    super(props)

    this.numCriteria = this.props.criteria.length
  }

  componentDidMount() {
    let rating_imgs = document.getElementsByClassName("rating-img")
    let rating_tooltips = document.getElementsByClassName(
      "criterion-rating-tooltip"
    )

    let popperInstance = null

    function create(i) {
      popperInstance = createPopper(rating_imgs[i], rating_tooltips[i], {
        placement: "top",
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, 0],
            },
          },
        ],
      })
    }

    function destroy() {
      if (popperInstance) {
        popperInstance.destroy()
        popperInstance = null
      }
    }

    function show(i) {
      rating_tooltips[i].setAttribute("data-show", "")
      create(i)
    }

    function hide(i) {
      rating_tooltips[i].removeAttribute("data-show")
      destroy()
    }

    const showEvents = ["mouseenter", "focus", "touchstart"]
    const hideEvents = ["mouseleave", "blur"]

    showEvents.forEach(event => {
      for (let i = 0; i < rating_imgs.length; i++) {
        rating_imgs[i].addEventListener(event, function() {
          show(i)
        })
      }
    })

    hideEvents.forEach(event => {
      for (let i = 0; i < rating_imgs.length; i++) {
        rating_imgs[i].addEventListener(event, function() {
          hide(i)
        })
      }
    })
  }

  render() {
    return (
      <div className="ratings-container">
        <div className="ratings-scroller">
          <div className="ratings">
            <table>
              <thead>
                <th className="table_category_header">{this.props.category}</th>
                {this.props.criteria.map(function(criterion) {
                  return (
                    <th>
                      <div>
                        <div>{criterion}</div>
                      </div>
                    </th>
                  )
                })}
              </thead>
              {this.props.children.map(function(product) {
                return (
                  <tr>
                    <td>
                      <div className="table-product-details">
                        <div className="table-product-name">
                          {product.props.name}
                        </div>
                        <div className="table-product-description">
                          <span
                            css={css`
                              font-weight: 600;
                            `}
                          >
                            Our take:{" "}
                          </span>
                          {product.props.description}
                        </div>
                      </div>
                    </td>
                    {product.props.ratings.map(function(rating) {
                      return (
                        <td>
                          <div className="criterion-rating">
                            <img
                              className={"rating-img rating-" + rating}
                              src={"/" + rating + "-rating.svg"}
                            />
                            <div className="criterion-rating-tooltip"></div>
                          </div>
                        </td>
                      )
                    })}
                  </tr>
                )
              })}
            </table>
          </div>
        </div>
      </div>
    )
  }
}

export default Ratings
